import { MST_DISTANCE } from './../model/transportation.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from "../model/user.model";
import { Transportation, TransportationSearch, MST_TRANSPORTATION } from "../model/transportation.model";


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class TransportationService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/Transportation';
    }


    GetTransportation(): Observable<MST_TRANSPORTATION[]> {
        return this.http.get<MST_TRANSPORTATION[]>(this.Url + "/GetTransportation", httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    GetDistanceList(): Observable<MST_DISTANCE[]> {
        return this.http.get<MST_DISTANCE[]>(this.Url + "/GetDistanceList", httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    SaveTransportation(data: MST_TRANSPORTATION): Observable<any> {
        return this.http.post<any>(this.Url + "", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    GetTransportationSearch(search: TransportationSearch): Observable<MST_TRANSPORTATION[]> {
        return this.http.post<MST_TRANSPORTATION[]>(this.Url + "/GetTransportationSearch", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getTransportationById(Id: number): Observable<Transportation> {
        return this.http.get<Transportation>(this.Url + "/" + Id.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    delTransportationById(TransportationId: number): Observable<any> {
        return this.http.post<any>(this.Url + "/deltransportation/" + TransportationId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetTransportationForExport(search: TransportationSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetTransportationForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<TransportationSearch>('GetTransportationForExport'))
        );
    }



    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/transportation.service.ts